import { render, staticRenderFns } from "./user_order_qx.vue?vue&type=template&id=63074f0c&scoped=true"
import script from "./user_order_qx.vue?vue&type=script&lang=js"
export * from "./user_order_qx.vue?vue&type=script&lang=js"
import style0 from "./user_order_qx.vue?vue&type=style&index=0&id=63074f0c&prod&scoped=true&lang=less"
import style1 from "./user_order_qx.vue?vue&type=style&index=1&id=63074f0c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63074f0c",
  null
  
)

export default component.exports